﻿const INTERIOR_ANGLES = ["dashboard", "frontseat", "rearseat"];
const FADE_DURATION = 300;

// ---------------------------------------------------------------------------
// Angle / URL helpers
// ---------------------------------------------------------------------------

function extractAngleFromPath(path) {
    const parts = path.split("/").pop().replace(".webp", "").split("_");
    return parts.length >= 2 ? parts[parts.length - 2].toLowerCase() : null;
}

function buildAngleMap(colour, cdnBase) {
    const map = {};
    (colour.anglePaths || []).forEach(function (path) {
        const angle = extractAngleFromPath(path);
        if (angle) map[angle] = cdnBase.replace(/\/$/, "") + "/" + path;
    });
    return map;
}

// ---------------------------------------------------------------------------
// Capture original slide HTML before flexslider clones them.
// Called synchronously at parse time for the inline pair, and from
// deal-page.js just before the modal pair is initialised.
// ---------------------------------------------------------------------------
const _originalSlides = {};

window.captureSlidesBefore = function (mainId, thumbId) {
    if (_originalSlides[mainId]) return;
    const mainUl = document.querySelector("#" + mainId + " ul.slides");
    const thumbUl = thumbId ? document.querySelector("#" + thumbId + " ul.slides") : null;
    if (!mainUl) return;
    const thumbLis = thumbUl ? Array.from(thumbUl.children) : [];
    _originalSlides[mainId] = Array.from(mainUl.children).map(function (li, i) {
        const img = li.querySelector("img[data-angle]");
        return {
            angle: img ? img.dataset.angle : null,
            mainHtml: li.outerHTML,
            thumbHtml: thumbLis[i] ? thumbLis[i].outerHTML : null
        };
    });
};

// Currently active colour angleMap — null means show all originals.
let _activeAngleMap = null;

// ---------------------------------------------------------------------------
// Teardown — flexslider 2.6.0 has no destroy method so we do it manually.
// ---------------------------------------------------------------------------
function teardownSlider(id) {
    const $el = $("#" + id);
    if (!$el.length || !$el.data("flexslider")) return;

    const slider = $el.data("flexslider");
    if (slider.animatedSlides) clearInterval(slider.animatedSlides);

    const $ul = $el.find("ul.slides");
    $ul.find(".clone").remove();

    const $vp = $el.find(".flex-viewport");
    if ($vp.length) $vp.before($ul).remove();

    $el.find(".flex-direction-nav").remove();
    $ul.removeAttr("style");
    $ul.children("li").removeAttr("style");
    $el.removeData("flexslider");
}

// ---------------------------------------------------------------------------
// Reinitialise a synced slider pair for a given colour (or null for default).
// Uses a ghost overlay clone to crossfade between the old and new state.
// ---------------------------------------------------------------------------
let _reinitInProgress = false;

function reinitSliderPair(mainId, thumbId, angleMap, options) {
    if (_reinitInProgress) return;
    _reinitInProgress = true;
    const $main = $("#" + mainId);
    const $thumb = thumbId ? $("#" + thumbId) : null;
    if (!$main.length || !_originalSlides[mainId]) return;

    // Remember which slide we're on so we can restore it after reinit
    const existing = $main.data("flexslider");
    const previousSlide = existing ? existing.currentSlide : 0;

    // Ghost overlay — clones the current carousel and fades it out over the
    // new content, giving the appearance of a crossfade
    function createGhost($el) {
        return $el.clone().removeAttr("id").css({
            position: "absolute", top: $el.position().top, left: $el.position().left,
            width: $el.outerWidth(), height: $el.outerHeight(),
            pointerEvents: "none", zIndex: 10,
            transition: "opacity " + FADE_DURATION + "ms ease", opacity: 1
        }).insertAfter($el);
    }
    $main.parent().css("position", "relative");
    const $mainGhost = createGhost($main);
    const $thumbGhost = $thumb ? createGhost($thumb) : null;

    // Lock heights to prevent collapse during teardown
    $main.css("min-height", $main.outerHeight() + "px");
    if ($thumb) $thumb.css("min-height", ($thumb.outerHeight() || 0) + "px");

    // Filter slides to only those relevant for this colour
    const slides = _originalSlides[mainId].filter(function (s) {
        if (!s.angle || INTERIOR_ANGLES.includes(s.angle) || !angleMap) return true;
        return !!angleMap[s.angle];
    });

    // Build slide HTML with colour image srcs baked in
    function buildSlideHtml(origHtml, angle, query) {
        if (!angleMap || !angle || INTERIOR_ANGLES.includes(angle) || !angleMap[angle]) return origHtml;
        const tmp = document.createElement("div");
        tmp.innerHTML = origHtml;
        const img = tmp.querySelector("img[data-angle]");
        if (img) img.src = angleMap[angle] + (query || "");
        return tmp.innerHTML;
    }

    // Teardown and rebuild under the ghost.
    // Hide only the ul.slides (not the whole carousel) immediately after teardown —
    // Chrome repaints the bare ul.slides before the ghost composites on top,
    // causing a flash of blank content. Hiding just the list avoids the thumbnail
    // carousel losing its scroll position, which happens if the wrapper is hidden.
    teardownSlider(mainId);
    if (thumbId) teardownSlider(thumbId);
    $main.find("ul.slides").css("visibility", "hidden");
    if ($thumb) $thumb.find("ul.slides").css("visibility", "hidden");

    const mainUl = $main.find("ul.slides")[0];
    const thumbUl = $thumb ? $thumb.find("ul.slides")[0] : null;
    if (mainUl) mainUl.innerHTML = slides.map(s => buildSlideHtml(s.mainHtml, s.angle, options.imageQuery)).join("");
    if (thumbUl) thumbUl.innerHTML = slides.filter(s => s.thumbHtml).map(s => buildSlideHtml(s.thumbHtml, s.angle, options.thumbQuery)).join("");

    const startAt = 0;
    const thumbSelector = thumbId ? "#" + thumbId : null;

    // Set counter immediately before flexslider's start fires
    $("#" + mainId + " .current-slide").text(startAt + 1);
    $("#" + mainId + " .total-slides").text(slides.length);

    // Safety fallback: if flexslider's start() never fires (e.g. 0 slides),
    // release the locks after a realistic delay so the page doesn't stay frozen.
    const _safetyRelease = setTimeout(function () {
        $main.css("min-height", "");
        $main.find("ul.slides").css("visibility", "");
        if ($thumb) {
            $thumb.css("min-height", "");
            $thumb.find("ul.slides").css("visibility", "");
        }
        _reinitInProgress = false;
    }, FADE_DURATION + 300);

    if (thumbSelector && thumbUl) {
        $(thumbSelector).flexslider(Object.assign({}, options.thumb, {
            asNavFor: "#" + mainId,
            startAt,
            start: function (thumbSlider) {
                thumbSlider.resize();
            }
        }));
    }

    $("#" + mainId).flexslider(Object.assign({}, options.main, {
        sync: thumbSelector, startAt,
        start: function (slider) {
            clearTimeout(_safetyRelease);
            $("#" + mainId + " .total-slides").text(slider.count);
            $("#" + mainId + " .current-slide").text(slider.currentSlide + 1);
            slider.resize();
            $main.css("min-height", "");
            $main.find("ul.slides").css("visibility", "");
            if ($thumb) {
                $thumb.css("min-height", "");
                $thumb.find("ul.slides").css("visibility", "");
                const thumbSlider = $thumb.data("flexslider");
                if (thumbSlider) thumbSlider.resize();
            }
            if ($mainGhost) $mainGhost.css("opacity", 0);
            if ($thumbGhost) $thumbGhost.css("opacity", 0);
            _reinitInProgress = false;
            setTimeout(function () {
                $mainGhost.remove();
                if ($thumbGhost) $thumbGhost.remove();
            }, FADE_DURATION);


        },
        after: function (slider) {
            $("#" + mainId + " .current-slide").text(slider.currentSlide + 1);
        }
    }));
}

const SLIDER_OPTIONS = {
    inline: {
        main: { animation: "slide", controlNav: false, animationLoop: true, slideshow: false, itemMargin: 0 },
        thumb: {
            animation: "slide", controlNav: false, animationLoop: true, slideshow: false, itemMargin: 8, itemWidth: 115, minItems: 3, maxItems: 6,
            start: function (carousel) { carousel.resize(); }
        },
        imageQuery: "?fixar=true&width=498&height=332",
        thumbQuery: "?fixar=true&width=120&height=80"
    },
    modal: {
        main: { animation: "slide", controlNav: false, animationLoop: true, slideshow: false, itemMargin: 0 },
        thumb: {
            animation: "slide", controlNav: false, animationLoop: true, slideshow: false, itemMargin: 8, itemWidth: 115, minItems: 3, maxItems: 8,
            start: function (carousel) { carousel.resize(); }
        },
        imageQuery: "?fixar=true&width=996&height=664",
        thumbQuery: "?fixar=true&width=120&height=80"
    }
};

// ---------------------------------------------------------------------------
// Simple image-only swap — used on the modal pair before it's initialised,
// so colour images are already correct when the modal first opens.
// ---------------------------------------------------------------------------
function swapCarouselImages(selector, angleMap, query) {
    document.querySelectorAll(selector + " img[data-angle]").forEach(function (img) {
        const angle = img.dataset.angle;
        img.src = (!INTERIOR_ANGLES.includes(angle) && angleMap && angleMap[angle])
            ? angleMap[angle] + (query || "")
            : img.dataset.originalSrc;
    });
}

// ---------------------------------------------------------------------------
// Hook into delayedInitModalFlexslider so the modal opens with the correct
// colour slides when a colour is already selected.
// ---------------------------------------------------------------------------
document.addEventListener("DOMContentLoaded", function () {
    // Capture modal slides immediately — before any colour reinit can bake
    // colour srcs into the DOM, which would corrupt the original slide data.
    window.captureSlidesBefore("dealpage-carousel2", "deal-thumbnails2");

    const originalDelayed = window.delayedInitModalFlexslider;
    if (typeof originalDelayed !== "function") return;

    window.delayedInitModalFlexslider = function () {
        if (_activeAngleMap === null) {
            originalDelayed();
            return;
        }
        const alreadyInit = !!$("#dealpage-carousel2").data("flexslider");
        if (alreadyInit) {
            reinitSliderPair("dealpage-carousel2", "deal-thumbnails2", _activeAngleMap, SLIDER_OPTIONS.modal);
            $("#dealpage-carousel2 img, #deal-thumbnails2 img").css("height", "auto");
        } else {
            originalDelayed();
            setTimeout(function () {
                reinitSliderPair("dealpage-carousel2", "deal-thumbnails2", _activeAngleMap, SLIDER_OPTIONS.modal);
                $("#dealpage-carousel2 img, #deal-thumbnails2 img").css("height", "auto");
            }, 300);
        }
    };
});

// ---------------------------------------------------------------------------
// Init
// ---------------------------------------------------------------------------
(function () {
    window.captureSlidesBefore("dealpage-carousel", "deal-thumbnails");

    function initColourSwatches() {
        const button = document.querySelector(".colour-swatch-button");
        const panel = document.querySelector(".colour-swatch-selection");
        const list = document.querySelector(".swatch-list");
        const pickerText = document.querySelector(".colour-picker-text");

        if (!button || !panel || !list) return;

        const coloursData = window.vehicleColoursData;
        const hasColourImages = coloursData && coloursData.colours && coloursData.colours.length > 0;

        panel.style.display = "none";

        list.addEventListener("click", function (e) {
            const item = e.target.closest(".swatch-item");
            if (!item) return;

            list.querySelectorAll(".swatch-item").forEach(function (el) {
                el.classList.remove("selected");
                el.setAttribute("aria-checked", "false");
            });
            item.classList.add("selected");
            item.setAttribute("aria-checked", "true");

            if (pickerText) pickerText.textContent = item.dataset.label || "Select a colour to preview";
            if (!hasColourImages) return;

            const colour = coloursData.colours.find(c => c.label === item.dataset.label);
            if (!colour) return;
            const angleMap = buildAngleMap(colour, coloursData.cdnBase);
            _activeAngleMap = angleMap;
            reinitSliderPair("dealpage-carousel", "deal-thumbnails", angleMap, SLIDER_OPTIONS.inline);
            swapCarouselImages("#dealpage-carousel2", angleMap, SLIDER_OPTIONS.modal.imageQuery);
            swapCarouselImages("#deal-thumbnails2", angleMap, SLIDER_OPTIONS.modal.thumbQuery);
        });

        button.addEventListener("click", function () {
            const isActive = button.classList.toggle("active");
            panel.style.display = isActive ? "block" : "none";
            button.childNodes.forEach(function (node) {
                if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
                    node.textContent = " " + (isActive ? "Hide colour examples" : "View colour examples") + " ";
                }
            });

            if (!isActive && hasColourImages && _activeAngleMap !== null) {
                // Panel is being hidden — reset to the default image set
                _activeAngleMap = null;
                list.querySelectorAll(".swatch-item").forEach(function (el) {
                    el.classList.remove("selected");
                    el.setAttribute("aria-checked", "false");
                });
                if (pickerText) pickerText.textContent = "Select a colour to preview";
                reinitSliderPair("dealpage-carousel", "deal-thumbnails", null, SLIDER_OPTIONS.inline);
                swapCarouselImages("#dealpage-carousel2", null, SLIDER_OPTIONS.modal.imageQuery);
                swapCarouselImages("#deal-thumbnails2", null, SLIDER_OPTIONS.modal.thumbQuery);

                // Teardown the modal slider and restore its original full slide HTML
                // so next open re-initialises from the default set, not the colour-filtered set
                teardownSlider("dealpage-carousel2");
                teardownSlider("deal-thumbnails2");
                const modalMainUl = document.querySelector("#dealpage-carousel2 ul.slides");
                const modalThumbUl = document.querySelector("#deal-thumbnails2 ul.slides");
                if (modalMainUl && _originalSlides["dealpage-carousel2"]) {
                    modalMainUl.innerHTML = _originalSlides["dealpage-carousel2"].map(function (s) {
                        const tmp = document.createElement("div");
                        tmp.innerHTML = s.mainHtml;
                        const img = tmp.querySelector("img");
                        if (img) {
                            let src = img.getAttribute("src") || "";
                            src = src.split("?")[0];
                            img.setAttribute("src", src + SLIDER_OPTIONS.modal.imageQuery);
                        }
                        return tmp.innerHTML;
                    }).join("");
                }
                if (modalThumbUl && _originalSlides["dealpage-carousel2"]) {
                    modalThumbUl.innerHTML = _originalSlides["dealpage-carousel2"].filter(s => s.thumbHtml).map(function (s) {
                        const tmp = document.createElement("div");
                        tmp.innerHTML = s.thumbHtml;
                        const img = tmp.querySelector("img");
                        if (img) {
                            let src = img.getAttribute("src") || "";
                            src = src.split("?")[0];
                            img.setAttribute("src", src + SLIDER_OPTIONS.modal.thumbQuery);
                        }
                        return tmp.innerHTML;
                    }).join("");
                }
                return;
            }

            // On first open, auto-select and trigger the first swatch
            if (isActive && hasColourImages && _activeAngleMap === null) {
                const firstItem = list.querySelector(".swatch-item");
                if (firstItem) firstItem.click();
            }
        });
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", initColourSwatches);
    } else {
        initColourSwatches();
    }
})();